module.exports = __webpack_public_path__ + "static/media/Michael.37b3cbff.png";